import classNames from "../classNames";
import dialog from "../Modal/dialog";

const defaultProps = {
  title: "Confirmation",
  icon: "bi bi-question-octagon-fill",
  message: "Are you sure you want to continue?",
  type: "warning",
};

function CustomConfirmation({
  title,
  icon,
  message,
  type,
  onConfirm,
  onCancel,
}) {
  return (
    <div className="p-4">
      <div className="d-flex flex-column text-center gap-2 align-items-center">
        <i
          className={classNames(icon, "text-" + type)}
          style={{ fontSize: "3rem" }}
        ></i>
        <div className="d-flex flex-column gap-1 container-fluid align-items-center">
          <h2 className="fw-bold m-0">{title}</h2>
          <p
            className="fs-6 m-0 col-11 text-dark"
            style={{ lineHeight: "1.2rem", fontSize: "1.2rem" }}
          >
            {message}
          </p>
        </div>
      </div>
      <div className="d-flex gap-2 mt-4">
        <button
          className="btn w-100 p-2"
          style={{ backgroundColor: "#DADBE0" }}
          onClick={() => dialog.close()}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary w-100 p-2"
          style={{ backgroundColor: "#14213D" }}
          onClick={() => onConfirm()}
        >
          Confirm
        </button>
      </div>
    </div>
  );
}

CustomConfirmation.defaultProps = defaultProps;
export default CustomConfirmation;
